import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':itemCategoryId'}/update`;

export const ROUTE: RouteDefinition = `${baseRoute}/:itemCategoryId/update`;

export const URL = (itemCategoryId: number): RouteDefinition => `${baseRoute}/${itemCategoryId}/update`;
